const s=s=>class extends s{constructor(){super();const s=document.createElement("style");s.textContent="{{ SEAMLESS_CSS_PLACEHOLDER }}",this.shadowRoot?.prepend(s)}};export{s as seamlessCustomElement};
//# sourceMappingURL=seamless-custom-element.mjs.map
